import React from "react";
import PropTypes from "prop-types";
import Currency from "../../../../../components/Currency/Currency";
import { _t } from "../../../../../utils/I18nUtils";
import "./BetContextModule.scss";

const trKey = "popUp.secureDeposit";

const BetContextModule = ({ potentialPayout, currency }) => {
    return (
        <div className="BetContextModule">
            <div className="top">
                <span className="picksReady">{_t(`${trKey}.betContextPicksReady`)}</span>
            </div>
            {potentialPayout > 0 && (
                <div className="couldWin">
                    <span className="label">{_t(`${trKey}.betContextCouldWin`)}</span>
                    <Currency
                        value={potentialPayout}
                        currency={currency}
                        className="gold-gradient-text payout"
                    />
                </div>
            )}
        </div>
    );
};

BetContextModule.propTypes = {
    potentialPayout: PropTypes.number,
    currency: PropTypes.string,
};

export default BetContextModule;
